import { AddressInfo } from './AddressInfo'

export enum JobRequestStatus {
    NO_JOB_CATEGORIES_FOR_MSA = 'NO_JOB_CATEGORIES_FOR_MSA',
    NO_REGISTERED_HAULERS_FOR_MSA = 'NO_REGISTERED_HAULERS_FOR_MSA',
    AT_JOB_DETAILS = 'AT_JOB_DETAILS',
    AT_JOB_AVAILABILITY = 'AT_JOB_AVAILABILITY',
    JOB_AVAILABILITY_BACK = 'JOB_AVAILABILITY_BACK',
    AT_REVIEW_JOB_DETAILS = 'AT_REVIEW_JOB_DETAILS',
    REVIEW_JOB_DETAILS_BACK = 'REVIEW_JOB_DETAILS_BACK',
    MISSING_CC_INFO = 'MISSING_CC_INFO',
    USER_HAS_ACTIVE_JOB = 'USER_HAS_ACTIVE_JOB',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
    CLIENT_INVALID_CHARGE_ACCOUNT = 'CLIENT_INVALID_CHARGE_ACCOUNT'
}

export interface JobRequestType {
    id?: string
    idHumanReadable?: string
    clientId?: string
    createDate?: number
    amount?: number
    address?: any
    msaId?: string
    jobCategoryId?: string
    status: JobRequestStatus
    coordinates?: string
    zipCode?: string
}



// WEBPACK FOOTER //
// ./src/types/JobRequest.ts